import domains from './domains.json';

export default {
  domains,
};
